<!-- eslint-disable vuejs-accessibility/label-has-for -->
<template>
  <div class="" >
    <input type="checkbox" id="card1" class="more" aria-hidden="true">
    <div class="sdk-btm__card content">
      <div class="sdk-btm__image cosmopolitan__img ">
        <div class="title-content">

        </div>
      </div>
      <div class="sdk-btm__text bloody-mary ">

        <div class="sdk-btm__text-ingredients" style="max-width: 690px;">
          <h2 class="title_card4">
            Kenny Flowers x Malibu: The Colada Collection
          </h2>
          <p class="kenny_description">
            Kenny Flowers' colorful resort wear is made for tropical escapes.
            So there's no one better to create Malibu-inspired clothing!
            Grab yours so you can fully embrace the Piña Colada lifestyle
            with this exclusive collab.
          </p>
          <div class="container_button">

            <button class="btn_cta2" @click="hrefLocation">shop now</button>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      selectedState: null,
    };
  },
  methods: {
    hrefLocation() {
      const gAnalitycs = {
        value: 'Click_Kenny_Shop_Button',
        event_action: 'Click_Kenny_Shop_Button',
        event_category: 'Button Click',
        event_label: 'Kenny Shop Button',
      };
      this.$gtag.event(gAnalitycs.value, gAnalitycs);
      window.open('https://www.kennyflowers.com/collections/kenny-flowers-x-malibu-escape-wear-colada-collection');
    },
  },
};
</script>

<style lang="scss">

.flip-card-left-container {

  .sdk-btm__card.content {
      @media screen and (max-width: 800px) {
        & {
          display: flex !important;
          flex-direction: column-reverse !important;
        }
      }
  }
}
.kenny_description {
  font-family: 'geoxe3';
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 140%;
  /* or 34px */

  text-align: center;

  color: #23161B;

  @media screen and (max-width: 600px) {
    font-family: 'geoxe3' !important;
    font-style: normal !important;
    font-weight: 500 !important;
    font-size: 18px !important;
    line-height: 140% !important;
    /* or 25px */

    text-align: center !important;

    color: #23161B !important;
    max-width: 300px !important;
    margin: 0 auto !important;
  }
}
</style>
